/**
 * PageHeader (iter66) — canonical dashboard page header.
 *
 * Consumes design tokens (@/design_tokens). Standardizes the h1 + subtitle
 * + actions layout that every dashboard page needs. Replaces one-off
 * `<div><h1><p></div>` snippets scattered across pages.
 *
 * Usage:
 *   <PageHeader
 *     title="Data Sources"
 *     subtitle="Manage your content feeds and data connections"
 *     icon={Database}
 *     actions={<><Button>Refresh</Button><Button>Import</Button></>}
 *     testId="data-sources-header"
 *   />
 */
import React from 'react';
import { TEXT, LAYOUT } from '@/design_tokens';

const PageHeader = ({ icon: Icon, title, subtitle, actions, testId, iconClassName }) => (
  <div
    className={`flex flex-col md:flex-row md:items-start md:justify-between gap-3 ${LAYOUT.headerBottomSpacing}`}
    data-testid={testId || 'page-header'}
  >
    <div className="min-w-0">
      <h1 className={`${TEXT.h1} inline-flex items-center gap-2`}>
        {Icon && (
          <Icon
            className={iconClassName || 'h-5 w-5 text-rose-400 shrink-0'}
            aria-hidden="true"
          />
        )}
        <span>{title}</span>
      </h1>
      {subtitle && (
        <p className={`${TEXT.subtitle} mt-0.5`}>{subtitle}</p>
      )}
    </div>
    {actions && (
      <div className="flex items-center gap-2 flex-wrap shrink-0">
        {actions}
      </div>
    )}
  </div>
);

export default PageHeader;
